import { newFrontendGuard } from './new-banking.guard';

/** `newFrontendGuard` for invoice pages, on the Postbox version cookie. */
export const newPostboxGuard = newFrontendGuard(partner => partner.postboxVersionCookie);
